export const expertiseData = [
  {
    id: "ppf-wrap",
    title: "Detailing",
    subtitle: "Paint Protection Film",
    description: "Bescherm uw waardevolle voertuig met onze premium detailing en Paint Protection Film.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado%20automotive_Website%20fotos%20%2010%20april-25.jpg",
    buttonText: "Meer over Detailing"
  },
  {
    id: "chiptuning",
    title: "CHIPTUNING",
    subtitle: "Performance Upgrade",
    description: "Optimaliseer de prestaties van uw voertuig met onze geavanceerde chiptuning services.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/chiptuning%20(1).jpg",
    buttonText: "Meer over Chiptuning"
  },
  {
    id: "modificaties",
    title: "MODIFICATIES",
    subtitle: "Custom Upgrades",
    description: "Van uitlaat upgrades tot complete carrosserie modificaties voor uw auto.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Tuning-4.jpg",
    buttonText: "Meer over Modificaties"
  },
  {
    id: "tuning-kits",
    title: "TUNING KITS",
    subtitle: "Complete Pakketten",
    description: "Complete tuning oplossingen voor optimale prestaties en betrouwbaarheid.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/IMG_0975%20(1).JPG",
    buttonText: "Meer over Tuning Kits"
  },
  {
    id: "autohotel",
    title: "AUTOHOTEL",
    subtitle: "Veilige Stalling",
    description: "Premium stalling voor uw waardevolle voertuigen in een beveiligde omgeving.",
    image: "https://images.unsplash.com/photo-1581362072978-14998d01fdaa?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Meer over Autohotel"
  },
  {
    id: "verkoop",
    title: "VERKOOP",
    subtitle: "Premium Occasions",
    description: "Exclusieve selectie van premium voertuigen voor de veeleisende koper.",
    image: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Bekijk Aanbod"
  },
  {
    id: "transport",
    title: "AUTO TRANSPORT",
    subtitle: "Veilig Vervoer",
    description: "Professioneel en verzekerd transport van uw kostbare voertuigen.",
    image: "https://images.unsplash.com/photo-1589793907316-f94025b46850?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Meer over Transport"
  },
  {
    id: "bandenhotel",
    title: "BANDENHOTEL",
    subtitle: "Seizoensopslag",
    description: "Professionele opslag en beheer van uw winter- en zomerbanden.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Banden%20hotel-1.jpg",
    buttonText: "Meer over Bandenhotel"
  },
  {
    id: "shop",
    title: "SHOP",
    subtitle: "Premium Producten",
    description: "Exclusieve selectie van automotive producten en accessoires.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//shop.jpg",
    buttonText: "Naar de Shop"
  },
  {
    id: "wrapping",
    title: "WRAPPEN",
    subtitle: "Car Wrapping",
    description: "Transformeer uw voertuig met premium car wrapping diensten.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//wrappen.jpg",
    buttonText: "Meer over Wrappen"
  },
  {
    id: "glascoating",
    title: "GLASCOATING",
    subtitle: "Lakbescherming",
    description: "Langdurige bescherming en glans voor uw voertuig met premium coating.",
    image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Meer over Glascoating"
  },
  {
    id: "restyle",
    title: "RESTYLE",
    subtitle: "Custom Design",
    description: "Unieke styling en personalisatie voor uw voertuig.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//restyle.jpg",
    buttonText: "Meer over Restyle"
  },
  {
    id: "ppf",
    title: "PPF",
    subtitle: "Paint Protection Film",
    description: "Bescherm uw waardevolle voertuig met onze premium Paint Protection Film oplossingen.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//ppf.jpg",
    buttonText: "Meer over PPF"
  },
  {
    id: "uitlaatsysteem",
    title: "UITLAATSYSTEEM",
    subtitle: "Performance Exhaust",
    description: "Premium uitlaatsystemen voor optimaal geluid en prestaties.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Meer over Uitlaatsystemen"
  },
  {
    id: "onderhoud",
    title: "ONDERHOUD",
    subtitle: "Premium Service",
    description: "Specialistisch onderhoud voor exclusieve voertuigen.",
    image: "https://images.unsplash.com/photo-1530046339160-ce3e530c7d2f?q=80&w=2940&auto=format&fit=crop",
    buttonText: "Meer over Onderhoud"
  },
  {
    id: "community",
    title: "COMMUNITY",
    subtitle: "Vermado Familie",
    description: "Word deel van de exclusieve Vermado Automotive community.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//community.jpg",
    buttonText: "Join de Community"
  }
] 